<template>
  <div class="card p-2">
    <div class="card-header">
      <h6 class="card-title">Video Highlight</h6>
    </div>
    <div class="card-body">
      <div
        :class="[
          'item-status__icon  btn btn-sm w-100',
          highlight_changed == 1
            ? 'btn-outline--warning'
            : 'btn-outline--danger',
        ]"
        role="button"
        @click.prevent="handleMakeHighlight()"
      >
        <i
          :class="[
            'fas',
            highlight_changed == 1 ? 'fa-check-circle' : 'fa-cross-circle',
          ]"
        ></i>
        {{ highlight_changed == 1 ? 'Free' : 'Paid' }}
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'highlight-changer',
  props: {
    item_id: {
      type: Number | String,
      required: true,
    },
    highlight: {
      type: Number | String,
      required: true,
    },
  },
  data() {
    return {
      highlight_changed: this.highlight,
    };
  },
  methods: {
    handleMakeHighlight() {
      const url = '/creator/video-item-highlight/' + this.item_id;
      axios
        .post(url, {
          isAjax: true,
        })
        .then((response) => {
          this.highlight_changed = !this.highlight_changed;
          notify('success', response.data.message);
        })
        .catch((error) => {
          notify('error', 'Something went wrong');
          console.error(error);
        });
    },
  },
};
</script>
